export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyDKFUM_8fqQqnvBLPLcTyfy4cbDmfnVW90',
    authDomain: 'froodini-d5dad.firebaseapp.com',
    databaseURL: 'https://froodini-d5dad.firebaseio.com',
    projectId: 'froodini-d5dad',
    storageBucket: 'froodini-d5dad.appspot.com',
    messagingSenderId: '454327297100',
    appId: '1:454327297100:web:8f6264711e515934d780e9',
    measurementId: 'G-YLVQ80ML3R'
  }
};
